import styled from '@emotion/styled'

import { Container } from '@/components/Container'
import { CONFIG } from '@/styles/emotion.config'

import { Input } from './Input'

export const MediaWithFormsContainer = styled(Container)`
  padding-top: 3rem;
  ${CONFIG.media.mobileLg} {
    padding: 2.5rem 0;
  }

  .media-with-forms__content {
    display: flex;
    flex-direction: row-reverse;
    align-items: center;
    justify-content: center;
  }
  .media-with-forms__inputs {
    margin-top: 1rem;
    max-width: 29.75rem;
    width: 100%;
  }

  .media-with-forms__content-wrapper {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 1rem;
    max-width: 35rem;
  }

  .media-with-forms__content--left {
    flex-direction: row;
  }

  .media-with-forms__image {
    margin-top: auto;
    margin-bottom: -3px;

    ${CONFIG.media.mobileLg} {
      display: none;
    }
  }

  ${CONFIG.media.mobileLg} {
  }

  .media-with-forms__title {
    font-size: 3rem;
    ${CONFIG.media.mobileLg} {
      font-size: 2rem;
    }
  }

  .media-with-forms__subtitle {
    font-size: 1.5rem;
    line-height: 1.75rem;
    ${CONFIG.media.mobileLg} {
      font-size: 1.125rem;
    }
  }
`

export const PremiumMessage = styled.div`
  display: flex;
  color: #0000ff;
  margin-top: 0.5rem;
  font-size: 0.875rem;
`

export const FormWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .document-consulting__footer__disclaimer {
    font-size: 0.75rem;
    line-height: 1rem;
    margin-top: -0.5rem;
    margin-bottom: 0.5rem;
  }

  .error-message {
    display: flex;
    color: #d6103b;
    margin-top: 0.5rem;
    font-size: 0.875rem;
  }

  .error-message-teste {
    display: flex;
    color: #ffffff;
    margin-top: 0.5rem;
    font-size: 0.875rem;
  }
`

export const Form = styled.form`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 3rem;
`

export const FormInput = styled(Input)`
  width: 100%;
  height: 100%;

  border: 0.125rem solid rgba(var(--theme-primary), 0.5);
  border-radius: 5.813rem 0 0 5.813rem;

  padding: 0.75rem 2.75rem 0.75rem 1rem;

  background-color: transparent;
  font-family: 'Roboto', sans-serif;
  font-size: 1rem;

  ${CONFIG.media.xlg} {
    padding: 1.375rem 2rem;
  }

  ::placeholder {
    color: rgb(var(--theme-text-dark-high));
    opacity: 0.9;
  }

  :focus {
    border: 0.125rem solid rgb(var(--theme-primary));
  }
`

export const FormSubmitButton = styled.button`
  height: 100%;
  border-radius: 5.813rem;
  margin-left: -2rem;
  cursor: pointer;

  padding: 0.75rem 2rem;

  display: flex;
  align-items: center;
  justify-content: center;

  color: white;
  background-color: rgb(var(--theme-primary));
  border: none;
  font-weight: bold;
  font-family: 'Roboto', sans-serif;
  font-size: 0.875rem;

  ${CONFIG.media.xlg} {
    font-size: 1rem;
    padding: 1.375rem 2rem;
  }

  transition: ease-in-out all 0.2s;

  :hover {
    filter: brightness(80%);
  }

  :focus {
    filter: brightness(80%);
  }
`
